export default {
  badge: 'Huy hiệu',
  open: 'Mở',
  close: 'Đóng',
  dismiss: 'Bỏ qua',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Hủy',
  },
  dataIterator: {
    noResultsText: 'Không tìm thấy kết quả nào',
    loadingText: 'Đang tải...',
  },
  dataTable: {
    itemsPerPageText: 'Số hàng mỗi trang:',
    ariaLabel: {
      sortDescending: 'Sắp xếp giảm dần.',
      sortAscending: 'Sắp xếp tăng dần.',
      sortNone: 'Không sắp xếp.',
      activateNone: 'Kích hoạt để bỏ sắp xếp.',
      activateDescending: 'Kích hoạt để sắp xếp giảm dần.',
      activateAscending: 'Kích hoạt để sắp xếp tăng dần.',
    },
    sortBy: 'Sắp xếp',
  },
  dataFooter: {
    itemsPerPageText: 'Số mục mỗi trang:',
    itemsPerPageAll: 'Toàn bộ',
    nextPage: 'Trang tiếp theo',
    prevPage: 'Trang trước',
    firstPage: 'Trang đầu',
    lastPage: 'Trang cuối',
    pageText: '{0}-{1} trên {2}',
  },
  dateRangeInput: {
    divider: 'đến',
  },
  datePicker: {
    itemsSelected: '{0} mục đã chọn',
    range: {
      title: 'Chọn ngày',
      header: 'Nhập ngày',
    },
    title: 'Chọn ngày',
    header: 'Nhập ngày',
    input: {
      placeholder: 'Nhập ngày',
    },
    ariaLabel: {
      previousMonth: 'Tháng trước',
      nextMonth: 'Tháng sau',
      selectYear: 'Chọn năm',
      previousYear: 'Năm trước',
      nextYear: 'Năm sau',
      selectMonth: 'Chọn tháng',
      selectDate: '{0}',
      currentDate: 'Hôm nay, {0}',
    },
  },
  noDataText: 'Không có dữ liệu',
  carousel: {
    prev: 'Ảnh trước',
    next: 'Ảnh tiếp theo',
    ariaLabel: {
      delimiter: 'Carousel slide {0} trên {1}',
    },
  },
  calendar: {
    moreEvents: '{0} nữa',
    today: 'Hôm nay',
  },
  input: {
    clear: 'Xóa {0}',
    prependAction: 'Hành động trước {0}',
    appendAction: 'Hành động sau {0}',
    otp: 'Vui lòng nhập ký tự OTP thứ {0}',
  },
  fileInput: {
    counter: '{0} tệp',
    counterSize: '{0} tệp (tổng cộng {1})',
  },
  fileUpload: {
    title: 'Kéo và thả tệp vào đây',
    divider: 'hoặc',
    browse: 'Chọn tệp',
  },
  timePicker: {
    am: 'SA',
    pm: 'CH',
    title: 'Chọn thời gian',
    hour: 'Giờ',
    minute: 'Phút',
    second: 'Giây',
    notAllowed: 'Giá trị không được phép',
  },
  pagination: {
    ariaLabel: {
      root: 'Điều hướng phân trang',
      next: 'Trang tiếp theo',
      previous: 'Trang trước',
      page: 'Đến trang {0}',
      currentPage: 'Trang hiện tại, Trang {0}',
      first: 'Trang đầu tiên',
      last: 'Trang cuối cùng',
    },
  },
  stepper: {
    next: 'Tiếp theo',
    prev: 'Trước',
  },
  rating: {
    ariaLabel: {
      item: 'Đánh giá {0} trên {1}',
    },
  },
  loading: 'Đang tải...',
  infiniteScroll: {
    loadMore: 'Tải thêm',
    empty: 'Không còn dữ liệu',
  },
  rules: {
    required: 'Trường này là bắt buộc',
    email: 'Vui lòng nhập một email hợp lệ',
    number: 'Trường này chỉ có thể chứa số',
    integer: 'Trường này chỉ có thể chứa số nguyên',
    capital: 'Trường này chỉ có thể chứa chữ cái in hoa',
    maxLength: 'Bạn phải nhập tối đa {0} ký tự',
    minLength: 'Bạn phải nhập tối thiểu {0} ký tự',
    strictLength: 'Độ dài của trường đã nhập không hợp lệ',
    exclude: 'Ký tự {0} không được phép',
    notEmpty: 'Vui lòng chọn ít nhất một giá trị',
    pattern: 'Định dạng không hợp lệ',
  },
  command: {
    search: 'Nhập lệnh hoặc tìm kiếm...',
  },
  hotkey: {
    then: 'sau đó',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Mũi tên lên',
    downArrow: 'Mũi tên xuống',
    leftArrow: 'Mũi tên trái',
    rightArrow: 'Mũi tên phải',
    backspace: 'Backspace',
    space: 'Khoảng trắng',
    plus: 'cộng',
    shortcut: 'Phím tắt: {0}',
    or: 'hoặc',
  },
  video: {
    play: 'Phát',
    pause: 'Tạm dừng',
    seek: 'Tìm kiếm',
    volume: 'Âm lượng',
    showVolume: 'Hiện điều khiển âm lượng',
    mute: 'Tắt tiếng',
    unmute: 'Bật tiếng',
    enterFullscreen: 'Toàn màn hình',
    exitFullscreen: 'Thoát toàn màn hình',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Chọn màu từ màn hình',
      hueSlider: 'Sắc độ',
      alphaSlider: 'Độ trong suốt',
      redInput: 'Đỏ',
      greenInput: 'Xanh lục',
      blueInput: 'Xanh lam',
      alphaInput: 'Độ trong suốt',
      hueInput: 'Sắc độ',
      saturationInput: 'Độ bão hòa',
      lightnessInput: 'Độ sáng',
      hexInput: 'Giá trị HEX',
      hexaInput: 'Giá trị HEX có độ trong suốt',
      changeFormat: 'Thay đổi định dạng màu',
    },
  },
}
